<!-- Main navbar -->
<div class="navbar navbar-dark navbar-static py-2">
	<div class="container-fluid">
		<div class="navbar-brand">
			<a href="index.html" class="d-inline-flex align-items-center">
				<img src="images/iit-madras-logo.png" alt="MANGO Logo" class="logo-circle">
				<img src="images/logo_text_light.svg" class="d-none d-sm-inline-block h-16px ms-3" alt="">
			</a>
		</div>

		<div class="d-flex justify-content-end align-items-center ms-auto">
			<ul class="navbar-nav flex-row">
				<li class="nav-item">
					<a href="/signup" class="navbar-nav-link navbar-nav-link-icon rounded ms-1">
						<div class="d-flex align-items-center mx-md-1">
						<i class="ph-user-circle-plus"></i>
						<span class="d-none d-md-inline-block ms-2">Register</span>
					</div>
					</a>
				</li>
				<li class="nav-item">
					<a href="/login" class="navbar-nav-link navbar-nav-link-icon rounded ms-1">
						<div class="d-flex align-items-center mx-md-1">
						<i class="ph-user-circle"></i>
						<span class="d-none d-md-inline-block ms-2">Login</span>
					</div>
					</a>
				</li>
			</ul>
		</div>
	</div>
</div>
<!-- /main navbar -->


<!-- Page content -->
<div class="page-content">

	<!-- Main content -->
	<div class="content-wrapper">

		<!-- Inner content -->
		<div class="content-inner">

			<!-- Content area -->
			<div class="content d-flex justify-content-center align-items-center">

				<!-- Password recovery form -->
				<form   *ngIf="!isResetMode" class="login-form needs-validation" novalidate>
					<div class="card mb-0">
						<div class="card-body">
							<div class="text-center mb-3">
								<div class="d-inline-flex bg-primary bg-opacity-10 text-primary lh-1 rounded-pill p-3 mb-3 mt-1">
									<i class="ph-arrows-counter-clockwise ph-2x"></i>
								</div>
								<h5 class="mb-0">Password recovery</h5>
								<span class="d-block text-muted">We'll send you instructions in email</span>
							</div>

							<div class="mb-3">
								<label class="form-label">Your email</label>
								<div class="form-control-feedback form-control-feedback-start">
									<input type="text" name="email" [(ngModel)]="email" class="form-control" placeholder="Enter your email" required>
									<div class="invalid-feedback">Enter your email address</div>
									<div class="form-control-feedback-icon">
										<i class="ph-at text-muted"></i>
									</div>
								</div>
							</div>

							<button type="button" class="btn btn-primary w-100" (click)="resetPassword()">
								<i class="ph-arrow-counter-clockwise me-2"></i>
								Reset password
							</button>
						</div>
					</div>
				</form>
				<!-- /password recovery form -->
				 <!-- Reset password form -->
				
						<form
							*ngIf="isResetMode"
							#resetForm="ngForm"
							class="login-form needs-validation"
							novalidate
							>
							<div class="card mb-0">
								<div class="card-body">
								
									<div class="text-center mb-3">
										<div class="d-inline-flex bg-success bg-opacity-10 text-success lh-1 rounded-pill p-3 mb-3 mt-1">
											<img src="images/iit-madras-logo.png" class="h-80px logo-circle" alt="MANGO Logo">
										</div>
										<h5 class="mb-0">Reset Your Password</h5>
										<span class="d-block text-muted">Please enter your new password below</span>
									</div>
								<div class="mb-3">
									<label class="form-label">New Password</label>
									<div class="position-relative">
									<input
										[type]="showPassword ? 'text' : 'password'"
										class="form-control pe-5"
										name="password"
										[(ngModel)]="password"
										#pwd="ngModel"
										required
										minlength="8"
									/>
									
									<span
										class="position-absolute top-50 end-0 translate-middle-y me-3"
										style="cursor: pointer; z-index: 10;"
										(click)="showPassword = !showPassword"
									>
										<i class="ph" [ngClass]="showPassword ? 'ph-eye': 'ph-eye-slash'"></i>
									</span>
									</div>
									<div class="text-danger mt-1" *ngIf="!passwordUpdateSuccess && pwd.touched && pwd.invalid">
									Password is required (min 8 chars)
									</div>
								</div>

							
								<div class="mb-3">
									<label class="form-label">Confirm Password</label>
									<div class="position-relative">
									<input
										[type]="showConfirmPassword ? 'text' : 'password'"
										class="form-control pe-5"
										name="confirmPassword"
										[(ngModel)]="confirmPassword"
										#cpwd="ngModel"
										required
										(keyup.enter)="updatePassword()"
									/>
								
									<span
										class="position-absolute top-50 end-0 translate-middle-y me-3"
										style="cursor: pointer; z-index: 10;"
										(click)="showConfirmPassword = !showConfirmPassword"
									>
										<i class="ph" [ngClass]="showConfirmPassword ? 'ph-eye': 'ph-eye-slash'"></i>
									</span>
									</div>
									<div class="text-danger mt-1" 
										*ngIf="!passwordUpdateSuccess && cpwd.touched && password && confirmPassword && password !== confirmPassword">
									Passwords do not match
									</div>
								</div>

							
								<button
									type="button"
									class="btn btn-success w-100"
									[disabled]="resetForm.invalid || password !== confirmPassword"
									(click)="updatePassword()"
								>
									Update Password
								</button>

								</div>
							</div>
							</form>

						<!-- /reset password form -->


			</div>
			<!-- /content area -->


			<!-- Footer -->
			<app-footer></app-footer>
			<!-- /footer -->

		</div>
		<!-- /inner content -->

	</div>
	<!-- /main content -->

</div>
<!-- /page content -->